<template>
  <v-app id="login">
    <!-- Sfondo a tutta pagina con trasparenza forte -->
    <div class="background-image"></div>

    <!-- Form di login su un layer superiore -->
    <v-main>
      <v-container fluid fill-height>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="8" md="6" lg="4" xl="3">
            <v-card class="login-card pa-8" elevation="10">
              <div class="text-center mb-8">
                <v-img src="@/assets/logo_small.png" alt="Logo" max-width="120px" contain class="mx-auto mb-4"></v-img>
                <h2 class="text-h4 font-weight-bold primary--text mb-4">
                  Elefante
                </h2>
                <h3 class="text-h6 font-weight-medium primary--text mb-6">Task Manager</h3>
                <v-divider class="mb-6"></v-divider>
                <p class="text-subtitle-2 text-secondary">Inserisci le tue credenziali per accedere</p>
              </div>

              <v-form @submit.prevent="login" class="mb-4">
                <v-text-field
                    name="username"
                    label="Username"
                    id="username"
                    v-model="username"
                    type="text"
                    required
                    prepend-inner-icon="mdi-account"
                    outlined
                    rounded
                    dense
                    class="mb-4"
                    :error-messages="usernameError"
                    @input="usernameError = ''"
                    color="primary"
                ></v-text-field>

                <v-text-field
                    name="password"
                    label="Password"
                    id="password"
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    required
                    outlined
                    rounded
                    dense
                    class="mb-6"
                    :error-messages="passwordError"
                    @input="passwordError = ''"
                    @keydown.enter="login"
                    color="primary"
                ></v-text-field>

                <v-btn
                    block
                    color="primary"
                    rounded
                    elevation="4"
                    large
                    class="font-weight-bold"
                    height="48"
                    :loading="loading"
                    @click="login"
                >
                  <v-img
                    src="/elephant.png"
                    max-width="24"
                    max-height="24"
                    class="mr-2"
                  ></v-img>
                  Accedi
                </v-btn>

                <div class="text-center mt-4">
                  <router-link to="/reset-password" class="text-decoration-none">
                    <span class="primary--text">Password dimenticata?</span>
                  </router-link>
                </div>
              </v-form>

              <div class="text-center mt-6">
                <v-divider class="mb-4"></v-divider>
                <div class="d-flex justify-center align-center">
                  <v-img
                    src="/elephant.png"
                    max-width="18"
                    max-height="18"
                    class="mr-2"
                  ></v-img>
                  <p class="text-caption text-secondary mb-0">
                    Elefante Task Manager © {{ new Date().getFullYear() }} IF65 srl. Tutti i diritti riservati.
                  </p>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import UserService from '/src/services/user.service.js';
import Vue from "vue";

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      username: '',
      password: '',
      showPassword: false,
      usernameError: '',
      passwordError: ''
    }
  },
  mounted() {
    // Aggiungiamo un'animazione di fade-in quando la pagina viene caricata
    document.querySelector('.login-card').classList.add('fade-in');
  },
  methods: {
    validateForm() {
      let isValid = true;

      if (!this.username) {
        this.usernameError = 'Username è obbligatorio';
        isValid = false;
      }

      if (!this.password) {
        this.passwordError = 'Password è obbligatoria';
        isValid = false;
      }

      return isValid;
    },
    login() {
      if (!this.validateForm()) return;

      this.loading = true;

      UserService.login(this.username, this.password).then(
          response => {
            localStorage.setItem('token', JSON.stringify(response.data.key));
            const csrfToken = Vue.$cookies.get('csrftoken');
            localStorage.setItem('csrf_token', csrfToken);

            this.$store.dispatch('setCurrentUser').then(() => {
              this.$dtoast.pop({
                preset: "success",
                content: "Accesso effettuato con successo",
              });

              // Aggiungiamo un piccolo ritardo per mostrare l'animazione di caricamento
              setTimeout(() => {
                this.$router.push({name: 'projects'});
              }, 500);
            });
          }
      ).catch(
          error => {
            this.loading = false;

            // Messaggio di errore più descrittivo
            let errorMessage = "Credenziali non valide. Riprova.";

            if (error.response && error.response.data) {
              if (error.response.data.non_field_errors) {
                errorMessage = error.response.data.non_field_errors[0];
              } else if (typeof error.response.data === 'string') {
                errorMessage = error.response.data;
              }
            }

            this.$dtoast.pop({
              preset: "error",
              content: errorMessage,
            });
          }
      )
    }
  }
}
</script>

<style scoped lang="css">
/* Stile per lo sfondo */
.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  z-index: 0;
}

/* Stile per la card di login */
.login-card {
  background-color: white !important;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2) !important;
  z-index: 10;
  transition: transform 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3) !important;
}

/* Stile per i campi di input */
.v-text-field.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.1);
}

/* Stile per il pulsante */
.v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px !important;
}
</style>
